export const tr = {
    'banners-add-archived-group': 'Arşivlenmiş reklam gruplarına reklam eklenemez.',
    'banners-limit-in-group': 'Reklam grubuna maksimum {limit} reklam eklenebilir.',
    error: 'Hata oluştu',
    'no-group-found': 'Gruplar bulunamadı',
    'search-by-group': 'Gruplara göre arama',
    'select-campaign-for-group': 'Soldaki sütunda kampanya seçin'
};
